import { isEmpty, isNotEmpty } from './isEmpty';

export function filterRecord<T = unknown>(
	record: Record<string, T>,
	predicate: (value: T, key: string) => boolean,
): Record<string, T> {
	if (isEmpty(record)) {
		return {};
	}

	const result: Record<string, T> = {};

	for (const [key, value] of Object.entries(record)) {
		if (predicate(value, key)) {
			result[key] = value;
		}
	}

	return result;
}

export function filterEmptyRecord<T = unknown>(record?: Record<string, T | undefined>): Record<string, T> {
	if (!record) {
		return {};
	}

	// Filter out any undefined or null values
	const filtered = filterRecord(record, (value) => isNotEmpty(value));

	// Cast to reflect that we've removed undefined values
	return filtered as Record<string, T>;
}

export function findRecord<T = unknown>(
	record: Record<string, T>,
	predicate: (value: T, key: string) => boolean,
): [string, T] | undefined {
	if (isEmpty(record)) {
		return undefined;
	}

	for (const [key, value] of Object.entries(record)) {
		if (predicate(value, key)) {
			return [key, value];
		}
	}

	return undefined;
}

export function mapRecord<T = unknown, U = unknown>(
	record: Record<string, T>,
	mapper: (value: T, key: string) => U,
): U[] {
	if (isEmpty(record)) {
		return [];
	}

	const result: U[] = [];

	for (const [key, value] of Object.entries(record)) {
		result.push(mapper(value, key));
	}

	return result;
}
